import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/GeneralTableActions";
import * as api from "../../api/GeneralTableApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getAllList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getAllList(action.payload);
        yield put(actions.setAllList(data || undefined));
        yield put(actions.resetList());
    } catch (error) {
        yield put(actions.setAllList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateRecord(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteRecord(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addRecord(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addRecord(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        console.log({ error });
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
        yield put(actions.resetPlants());
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMailGroups() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMailGroups();
        yield put(actions.setMailGroups(data || undefined));
    } catch (error) {
        yield put(actions.setMailGroups(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMailPeriods() {
    try {
        const { data } = yield api.getMailPeriods();
        yield put(actions.setMailPeriods(data || undefined));
    } catch (error) {
        yield put(actions.setMailPeriods(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownPlaceByGroupId(action) {
    try {
        const { data } = yield api.getBreakDownPlaceByGroupId(action.payload);
        yield put(actions.setBreakDownPlaceByGroupId(data || undefined));
        yield put(actions.resetBreakDownPlaceByGroupId());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownReasonGroups() {
    try {
        const { data } = yield api.getBreakDownReasonGroups();
        yield put(actions.setBreakDownReasonGroups(data || undefined));
        yield put(actions.resetBreakDownReasonGroups());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_ALL_LIST_FOR_GENERAL_TABLE, getAllList);
    yield takeEvery(actions.Types.UPDATE_RECORD_OF_LIST, updateRecord);
    yield takeEvery(actions.Types.DELETE_RECORD_OF_LIST, deleteRecord);
    yield takeEvery(actions.Types.ADD_RECORD_OF_LIST, addRecord);
    yield takeEvery(actions.Types.GET_PLANTS_FOR_GENERAL_TABLE, getPlants);
    yield takeEvery(actions.Types.GET_MAIL_GROUPS_FOR_GENERAL_TABLE, getMailGroups);
    yield takeEvery(actions.Types.GET_MAIL_PERIODS_FOR_GENERAL_TABLE, getMailPeriods);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_PLACE_BY_ID_FOR_GENERAL_TABLE, getBreakDownPlaceByGroupId);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_GROUPS_FOR_GENERAL_TABLE, getBreakDownReasonGroups);
}

const generalTableSaga = [fork(watchAll)];

export default generalTableSaga;
